<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formSubmit)" novalidate>

            <div class="step" v-if="currentStep == 1">
                <h2>Neste momento<br>está grávida?</h2>

                <validation-provider class="tw-w-full tw-w-block" name="pregnant" rules="required" v-slot="{ classes }" key="select-step-1">
                    <div class="input-group input-group-pregnant" :class="classes">
                        <select v-model="pregnant" class="input-pregnant">
                            <option selected disabled value=""></option>
                            <option value="sim">Sim</option>
                            <option value="nao">Não</option>
                        </select>
                        <label :class="{'select-placeholder' : !pregnant}">Selecione</label>
                    </div>
                    <button @click.prevent="nextStep">Seguinte</button>
                </validation-provider>
            </div>

            <div class="step" v-if="currentStep == 2">
                <h2>Para quando espera o<br>nascimento do bebé?</h2>

                <validation-provider class="tw-w-full tw-w-block" name="baby_date" rules="required" v-slot="{ classes }" key="select-step-2">
                    <div class="input-group input-group-baby_date" :class="classes">
                        <select v-model="baby_date" class="select-input input-baby_date">
                            <option selected disabled value=""></option>
                            <option v-for="(month, index) in availableMonths" :value="month" :key="index">{{month}}</option>
                        </select>
                        <label :class="{'select-placeholder' : !baby_date}">Selecione</label>
                    </div>
                    <button @click.prevent="nextStep">Seguinte</button>
                </validation-provider>
            </div>

            <div class="step" v-if="currentStep == 3">
                <h2 class="tw-mb-16">Qual é a sua Data de Nascimento?</h2>
                <div class="tooltip" :class="{ 'active' : tooltip }">
                    <small>O preenchimento correcto deste campo será decisivo<br class="tw-hidden lg:tw-block">para a selecção dos candidatos.</small>
                </div>

                <validation-provider class="tw-w-full tw-w-block" name="birthdate" key="select-step-3" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-birthdate" :class="classes">
                        <input type="tel" v-model="birthdate" class="input-birthdate" placeholder="dd/mm/aaaa" v-mask="{alias: 'datetime', inputFormat: 'dd/mm/yyyy', placeholder: 'dd/mm/aaaa', showMaskOnHover: false, showMaskOnFocus: true}" @click="tooltip = true"/>
                        <label class="invalidAge" v-if="invalidAge || invalidYear">Data de nascimento inválida</label>
                    </div>
                    <button @click.prevent="nextStep">Seguinte</button>
                </validation-provider>
            </div>

            <div class="step" v-if="currentStep == 4">
                <h2>Tem filhos com idade<br>até aos 3 anos?</h2>

                <validation-provider class="tw-w-full tw-w-block" name="kids_until_3y" key="select-step-4" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-kids" :class="classes">
                        <select v-model="kids_until_3y" class="input-kids">
                            <option selected disabled value=""></option>
                            <option value="nao">Não</option>
                            <option value="sim 1 filho">Sim, tenho 1 filho com menos de 3 anos</option>
                            <option value="sim 2 filhos">Sim, tenho 2 filho com menos de 3 anos</option>
                        </select>
                        <label :class="{'select-placeholder' : !kids_until_3y}">Selecione</label>
                    </div>
                    <button @click.prevent="nextStep">Seguinte</button>
                </validation-provider>
            </div>

            <div class="step tw-pt-3" v-if="currentStep == 5">
                <validation-provider class="tw-w-full tw-w-block" name="name" key="select-name" rules="required|alpha_spaces" v-slot="{ classes }">
                    <div class="input-group input-group-name" :class="classes">
                        <input type="text" v-model="name" class="input-name" placeholder=" "/>
                        <label>Nome e Apelido</label>
                    </div>
                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" name="email" key="select-email" rules="email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                    <div class="input-group input-group-email" :class="classes">
                        <input type="text" v-model="email" class="input-email" placeholder=" "/>
                        <label>Email {{ errors [0]}}</label>
                    </div>
                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" name="zip" key="input-zip" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-zip" :class="classes">
                        <input type="text" v-model="zip" class="input-zip" v-mask="'####-###'" placeholder=" "/>
                        <label>Código Postal</label>
                    </div>
                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" name="operator" key="select-operator" rules="required" v-slot="{ classes }">
                    <div class="input-group input-group-operator" :class="classes">
                        <select v-model="operator" class="input-operator">
                            <option selected disabled value=""></option>
                            <option value="meo">MEO</option>
                            <option value="nos">NOS</option>
                            <option value="vodafone">Vodafone</option>
                            <option value="nowo">NOWO</option>
                            <option value="outros">Outros</option>
                        </select>
                        <label :class="{'select-placeholder' : !operator}">Operador de telefone</label>
                    </div>
                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" name="phone" key="input-phone" rules="required|phone:pt" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', phone: ' ' }">
                    <div class="input-group input-group-phone" :class="classes">
                        <input type="tel" v-model="phone" class="input-phone" v-mask="'#########'" placeholder=" "/>
                        <label>Telemóvel {{ errors [0]}}</label>
                    </div>
                </validation-provider>

                <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                    <div class="mb-2">
                        <div class="form-check p-0">
                            <label class="form-check-label" :class="classes">
                                <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                <span class="checkmark"></span>
                                <span class="tw-text-white tw-text-left">Autorizo a Kantar Worldpanel a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                            </label>
                        </div>
                    </div>
                </validation-provider>

                <div class="tw-text-center tw-mt-4">
                    <button type="submit" class="btn-cta" id="submit" :disabled="formLoading">
                        Participar
                    </button>
                </div>

            </div>

            <div class="step-bullets">
                <div :class="{filled: currentStep == 1 }"></div>
                <div :class="{filled: currentStep == 2 }"></div>
                <div :class="{filled: currentStep == 3 }"></div>
                <div :class="{filled: currentStep == 4 }"></div>
                <div :class="{filled: currentStep == 5 }"></div>
            </div>

        </form>
    </validation-observer>
</template>

<script>
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            name: '',
            email: '',
            phone: '',
            zip: '',
            operator: '',
            pregnant: '',
            baby_date: '',
            birthdate: '',
            kids_until_3y: '',
            page: 'gravidas.inquerito-kantar.com',

            currentStep: 1,
            tooltip: false,
            availableMonths: [],
            invalidAge: false,
            invalidYear: false,

            formLoading: false,
            usedClasses: ['.has-error'],
        };
    },
    mounted() {
        this.getNext9Months();
    },
    methods: {
        getNext9Months() {
            const names = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

            const now = new Date();
            let month = now.getMonth();
            let year = now.getFullYear();

            const res = [];
            for (let i = 0; i < 9; ++i) {
                res.push(`${names[month]} ${year}`);
                if (++month === 12) {
                    month = 0;
                    ++year;
                }
            }

            this.availableMonths = res;
        },
        /**
         * @param {number} min Minimum age
         * @param {number} max Maximum age
         */
        calculateBirthdate(min, max) {
            const birthYear = this.birthdate.substr(this.birthdate.length - 4);
            const age = new Date().getFullYear() - birthYear;
            const reg = new RegExp('^[0-9/]*$');
            if (birthYear < (new Date().getFullYear() - 100) || birthYear > (new Date().getFullYear() - 15)) {
                this.invalidYear = true;
                this.invalidAge = false;
                document.querySelector('.input-birthdate').parentNode.classList.add('has-error');
                return false;
            }
            if (reg.test(this.birthdate) == false) {
                this.invalidAge = false;
                this.invalidYear = false;
                document.querySelector('.input-birthdate').parentNode.classList.add('has-error');
                return false;
            }
            if (age >= min && age <= max) { // Allowed ages in between min and max
                this.invalidAge = false;
                this.invalidYear = false;
                return true;
            }
            this.invalidAge = true;
            document.querySelector('.input-birthdate').parentNode.classList.add('has-error');
            return false;
        },
        nextStep() {
            switch (this.currentStep) {
            case 1:
                if (this.pregnant == '') {
                    document.querySelector('.input-pregnant').parentNode.classList.add('has-error');
                    return false;
                }
                this.currentStep++;

                break;
            case 2:
                if (this.baby_date == '') {
                    document.querySelector('.input-baby_date').parentNode.classList.add('has-error');
                    return false;
                }
                this.currentStep++;

                break;
            case 3:
                if (!this.birthdate) {
                    document.querySelector('.input-birthdate').parentNode.classList.add('has-error');
                    return false;
                }
                // Condition that changes (min, max)
                if (this.calculateBirthdate(15, 100)) {
                    this.currentStep++;
                }

                break;
            case 4:
                if (this.kids_until_3y == '') {
                    document.querySelector('.input-kids').parentNode.classList.add('has-error');
                    return false;
                }
                this.currentStep++;

                break;
            default:
                console.log('switch default :(');
                return false;
            }
        },
        formSubmit() {
            this.formLoading = true;

            let cmpInfo = {
                vendor:{
                    consents: [],
                },
                tcString: '',
            };

            try{
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                user_agent: window.navigator.userAgent,
                pubid: this.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                ua_device: this.$store.state.ua_device,
                ua_browser: this.$store.state.ua_browser,
                ua_os: this.$store.state.ua_os,
                token: this.$store.state.token,

                pregnant: this.pregnant,
                baby_date: this.baby_date,
                birthdate: this.birthdate,
                kids_until_3y: this.kids_until_3y,

                name: this.name,
                email: this.email,
                phone: this.phone,
                zip: this.zip,
                operator: this.operator,
                page: this.page,

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
                mclic: process.env.VUE_APP_MCLIC,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.birthdate) {
                        this.$store.state.formError = true;
                    }
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = ' já registado';
                    }
                    if (error.response.data.errors.phone) {
                        error.response.data.errors.phone = ' já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
